<template>
  <div>
    <K-Loading :Loading="Loading" v-if="!datas"></K-Loading>
    <div v-else>

      <!-- 背景音乐 -->
      <K-Music :Music="datas.music"></K-Music>

      <div class="swiper-container banner">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-if="datas.focus && datas.focus_pics_is_show == 1" v-for="(item,index) in datas.focus" v-bind:key="index"><img :src="item.img"></div>
        </div>
      </div>

      <div class="MainBox">
        <div>
          <div class="line"></div>
          <ul class="MainDatasBox">
            <li class="MainData" v-if="datas.verify">
              <p class="MainDataLeft letter">防伪码：</p>
              <p class="MainDataRight" v-text="datas.verify"></p>
            </li>
            <li class="MainData">
              <p class="MainDataLeft">查询次数：</p>
              <p class="MainDataRight" v-text="datas.scan_count"></p>
            </li>
            <li class="MainData">
              <p class="MainDataLeft">查询时间：</p>
              <p class="MainDataRight" v-text="datas.scan_first_time"></p>
            </li>
            <li class="MainData">
              <p class="MainDataLeft">查询地点：</p>
              <p class="MainDataRight">
                <a v-if="datas.scan_first_address" v-text="datas.scan_first_address"></a>
                <a v-else>正在获取中...</a>
              </p>
            </li>
            <li class="MainData">
              <p class="MainDataLeft">查询结果：</p>
              <p class="MainDataRight">您查询的防伪码为正牌产品，请放心使用！</p>
            </li>
          </ul>
        </div>
      </div>

      <footer v-if="datas.business.linkphone" v-text="datas.business.linkphone"></footer>

    </div>
  </div>
</template>

<script>
let self;
import axios from 'axios'
import Swiper from 'swiper'
import Loading from '@/components/Loading.vue'
import Music from '@/components/Music.vue'
export default {
  name: 'AntiFake01',
  components: {
    'K-Loading': Loading,
    'K-Music': Music
  },
  data () {
    return {
      code:null,
      count:2,
      datas:null,
      Loading:{
        type:1,
        txt:"数据请求中..."
      },
      Music:{
        url:null,
        type:false
      }
    }
  },
  created () {
    self = this;

    //判断是演示还是真实码标
    if(this.$route.query.type == "demo"){
      self.GetDemoDatas(this.$route.query.pid,this.$route.query.rid);  //获取演示模板信息
    }else{
      self.code = self.GetCode();
      self.GetDatas();  //获取码标信息
    }

    document.body.style.backgroundColor = "#FFF";
  },
  updated () {
    new Swiper('.banner',{
      autoplay: 3000, //可选选项，自动滑动
      loop: true, //可选选项，开启循环
    })
  },
  methods:{
    GetDemoDatas (pid,rid) {
      axios.get(self.GetServerUrl(1)+"template_product/"+pid+"/"+rid)
      .then(function (response){
        let datas = response.data.meta;
        let defaultDatas = JSON.parse(datas.default_basic.config_value);  //初始化默认信息

        if(datas.scan_count){
          datas.scan_count = datas.scan_count;
        }else{
          datas.scan_count = 1;
        }
        datas.scan_first_time = "2017-10-31 12:12";
        datas.scan_first_address = "广东省深圳市";
        if(datas.focus){
          datas.focus = JSON.parse(datas.focus);
        }
        if(datas.ref){
          datas.ref = JSON.parse(datas.ref);
        }else{
          if(defaultDatas.ref){
            datas.ref = JSON.parse(defaultDatas.ref);
          }
        }
        if(datas.menu){
          datas.menu = JSON.parse(datas.menu);
        }
        if(datas.batch){
          datas.batch = JSON.parse(datas.batch);
          datas.batch.qc = JSON.parse(datas.batch.qc);
        }
        if(datas.music && datas.music_is_show == 1){
          try {
            datas.music = JSON.parse(datas.music);
          } catch (error) {
            console.error(error)
          }
        }
        if(datas.video){
          datas.video = JSON.parse(datas.video);
        }
        datas.activity_is_show = 1;

        //默认信息
        if(!datas.process){
          datas.process = defaultDatas.process;
        }
        if(!datas.process_demo){
          datas.process_demo = defaultDatas.process_demo;
        }
        if(!datas.dealer){
          datas.dealer = defaultDatas.dealer;
        }
        self.datas = datas;

        // document.title = self.datas.business.name;  //设置页面标题
      }).catch(function (error){
        console.log(error)
        self.Loading.type = 3;
        self.Loading.txt = self.ErrorHint(error);
      })
    },
    GetDatas () {
      axios.get(self.GetServerUrl(1)+"query/"+self.code)
      .then(function (response){
        let datas = response.data.meta.product_template;
        datas.scan_count = response.data.meta.scan_count;  //扫码次数
        datas.scan_first_time = response.data.meta.scan_first_time;  //扫码时间
        datas.scan_first_address = response.data.meta.scan_first_address;  //扫码地点
        //焦点图
        if(datas.focus){
          datas.focus = JSON.parse(datas.focus);
        }
        //自定义栏目
        if(datas.ref){
          datas.ref = JSON.parse(datas.ref);
        }
        //自定义菜单
        if(datas.menu){
          datas.menu = JSON.parse(datas.menu);
        }
        if(datas.music && datas.music_is_show == 1){
          try {
            datas.music = JSON.parse(datas.music);
          } catch (error) {
            console.error(error)
          }
        }
        if(datas.video){
          datas.video = JSON.parse(datas.video);
        }
        datas.activity_is_show = 1;
        self.datas = datas;

        // document.title = self.datas.business.name;  //设置页面标题
      }).catch(function (error){
        console.log(error)
        self.Loading.type = 3;
        self.Loading.txt = self.ErrorHint(error);
      })
    },
    PreviewImgs () {
      self.$viewer.show();
      self.$viewer.update();
    }
  }
}
</script>

<style scoped>
  .letter{
    letter-spacing: .19rem;
  }
  .banner{
    min-height: 8rem;
    background: #EEE;
  }
  .banner img{
    display: block;
    width: 100%;
  }
  .MainBox{
    margin:.7rem;
    overflow: hidden;
    border-radius: .3rem;
    box-shadow: 0 0 5px rgba(100,100,100,.5);
  }
  .line{
    height:.4rem;
    background-color: #ee7001;
  }
  .MainDatasBox{
    padding:.8rem .6rem;
  }
  .MainData{
    font-size:.58rem;
    overflow: hidden;
    line-height:.8rem;
    margin-top:.45rem;
  }
  .MainData:first-child{
    margin-top:0;
  }
  .MainDataLeft{
    float: left;
    width: 3.2rem;
    color:#444;
  }
  .MainDataRight{
    float: left;
    color:#ee7001;
    width: calc(100% - 3.2rem);
  }
  footer{
    position: fixed;
    bottom:0;left:0;
    right:0;
    text-align: center;
    padding:.45rem 0;
    color:#FFF;
    font-size: .58rem;
    background-color: #ee7001;
  }
</style>



// WEBPACK FOOTER //
// src/view/AntiFake01.vue